import { defineComponent as _defineComponent } from 'vue'
import MenuUser from '@/components/partials/navigation/MenuUser.vue';
import MenuPortfolios from '@/components/partials/navigation/MenuPortfolios.vue';
import { DashboardRepresentation } from '@/clients/dashboardapi/v2';
import { ReportConfigDlg } from '@/modules/ctx-report-preview';
import MissingLicenseDlg from '@/modules/shared/components/dialogs/generic/MissingLicenseDlg.vue';
import { Port } from '@/modules/shared/Port';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const showMissingLicenseDlg = ref<boolean>(false);
const showUserMenu = ref<boolean>(false);
const showPortfoliosMenu = ref<boolean>(false);
const showReportConfigDlg = ref<boolean>(false);
const dashboardForReport = ref<DashboardRepresentation|null>(null);

const route = useRoute();

function onRouteChanged() {
    showUserMenu.value = false;
    showPortfoliosMenu.value = false;
}

async function createReport(dashboardKey: string): Promise<void> {
    dashboardForReport.value = await Port.dashboards.getDashboardByKey(dashboardKey) || null;
    showReportConfigDlg.value = true;
    showUserMenu.value = false;
    showPortfoliosMenu.value = false;
}

function onLicenseError() {
    showUserMenu.value = false;
    showMissingLicenseDlg.value = true;
}

watch(route, onRouteChanged, { deep: true });

return { __sfc: true,showMissingLicenseDlg, showUserMenu, showPortfoliosMenu, showReportConfigDlg, dashboardForReport, route, onRouteChanged, createReport, onLicenseError, MenuUser, MenuPortfolios, ReportConfigDlg, MissingLicenseDlg }
}

})